import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsektaworld } from "../../../../data/projects/ekta/data";

export const EktaParksville = () => {
  const {
    parksvillephase4: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsektaworld;

  return (
    <>
      <Helmet>
        <title>Ekta Parksville Phase 4, Virar West, Mumbai | Luxury 1 & 2 BHK Flats</title>

        <meta
          name="description"
          content="Explore Ekta Parksville Phase 4 in Virar West, Mumbai, offering premium 1 & 2 BHK flats with modern amenities, excellent connectivity, and a vibrant lifestyle. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Ekta Parksville Phase 4, Ekta Parksville Virar West, Ekta Parksville Mumbai, 1 BHK flats in Virar, 2 BHK flats in Virar West, luxury apartments in Mumbai, Virar West property, Ekta World projects"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/ekta-parksville-phase-4-virar-west-mumbai"
        />

        <meta
          name="robots"
          content="index, follow"
        />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
